module.exports = __webpack_public_path__ + "img/17.535c779d.png";